var map = {
	"./conditions-off-piste.svg": 824,
	"./conditions-piste.svg": 825,
	"./conditions-runs.svg": 826,
	"./next-significant-snowfall.svg": 827,
	"./next-snowfall.svg": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 823;